var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Total_Fax"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Fax",
    clipPath: "url(#clip-Total_Fax)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local_printshop",
    transform: "translate(5.188 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M20.7,8.6H19.6V3H6.4V8.6H5.3A3.327,3.327,0,0,0,2,11.963v6.722H6.4v4.482H19.6V18.685H24V11.963A3.327,3.327,0,0,0,20.7,8.6ZM8.6,5.241h8.8V8.6H8.6Zm8.8,15.685H8.6V16.444h8.8Zm2.2-4.482V14.2H6.4v2.241H4.2V11.963a1.114,1.114,0,0,1,1.1-1.12H20.7a1.114,1.114,0,0,1,1.1,1.12v4.481Z",
    transform: "translate(-3.188 -3)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFax);
export default __webpack_public_path__ + "static/media/Total_Fax.70463df048dc398f3921ee35c3c01e9d.svg";
export { ForwardRef as ReactComponent };